/** @jsx h */
const MapFilterCheckbox = ({
  option,
  filterName,
  handleChange,
  pluginNamespace,
}) => {
  return (
    <li class="input-filter input-filter--map">
      <input
        id={`${filterName}-${option.value}`}
        type="checkbox"
        class="input-filter__input"
        name={`${pluginNamespace}[filter][]`}
        value={`${filterName}:${option.value}`}
        data-label={`${filterName}-${option.label}`}
        onChange={handleChange}
        checked={option.selected}
      />
      <label
        htmlFor={`${filterName}-${option.value}`}
        class="input-filter__label"
      >
        <span class="input-filter__label-text">
          <span class="input-filter__icon icon icon--check">
            <svg class="icon__svg" role="img" aria-hidden="true">
              <use href="#icon-check" />
            </svg>
          </span>
          {option.label}
        </span>
      </label>
    </li>
  );
};

export default MapFilterCheckbox;
